module.exports = __webpack_public_path__ + "img/aegaming.82acd2a2.png";